module.exports = __webpack_public_path__ + "img/activity_birthday.73259ad7.jpg";